import {
  Box,
  styled,
  TableContainer as TableContainerStyles,
} from '@mui/material';

interface TitleBoxStatusProps {
  status: boolean;
}

export const TableContainer = styled(TableContainerStyles)`
  background: ${({ theme }) => theme.palette.common.white};
  border-radius: 6px;
  margin-top: 20px;
`;

export const TableTitle = styled(Box)`
  color: rgba(0, 0, 0, 0.54);
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`;

export const TitleBox = styled(Box)`
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TitleBoxStatus = styled(Box)`
  border-radius: 50px;
  padding: 4px 12px;
  width: fit-content;
  height: 28px;
  color: ${({ theme }) => theme.palette.common.white};
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;

  background-color: ${(props: TitleBoxStatusProps) =>
    props.status ? '#4CAF50' : '#E31B0C'};
`;
